<div ng-controller="unusedTagsReportController as ctrl" class="modal-view report-view">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>


